<template>
  <section class="gs-portal-join">
    <div class="embed-container gs-portal-join__video">
      <iframe
        v-if="useCustomVideo && isYouTubeService"
        :src="'https://www.youtube.com/embed/' + funnelResource.video_details.id"
      ></iframe>
      <iframe
        v-else-if="useCustomVideo && isVimeoService"
        :src="'https://player.vimeo.com/video/' + funnelResource.video_details.id"
      ></iframe>
      <iframe v-else src="https://www.youtube.com/embed/LRfMEiWcV1M?rel=0"></iframe>
    </div>

    <div class="gs-portal-join__copy">
      <p class="gs-portal-join__eyebrow">Affiliate portal</p>
      <h2 class="gs-portal-join__title">
        {{ $t('frontend_groovesell_resources_havent_signed_aff_funnel_desc') }}
      </h2>
      <p class="gs-portal-join__text">
        Join the affiliate program to unlock your tracking link, swipes, banners and
        the rest of the promo material.
      </p>
      <div class="gs-portal-join__actions">
        <gs-button variant="primary" @click="signupToPromoteFunnel()">
          {{ $t('frontend_resources_signup_to_funnel') }}
        </gs-button>
      </div>
    </div>
  </section>
</template>

<script>
import Cookies from 'js-cookie';
import FunnelAffiliate from '@/models/FunnelAffiliate';

export default {
  props: {
    funnelResource: {
      type: Object,
      default: () => {},
    },
    selectedPromoLink: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    useCustomVideo() {
      return this.funnelResource && this.funnelResource.use_custom_video;
    },
    isYouTubeService() {
      return (
        this.useCustomVideo &&
        this.funnelResource.video_details &&
        this.funnelResource.video_details.id &&
        this.funnelResource.video_details.service === 'youtube'
      );
    },
    isVimeoService() {
      return (
        this.useCustomVideo &&
        this.funnelResource.video_details &&
        this.funnelResource.video_details.id &&
        this.funnelResource.video_details.service === 'vimeo'
      );
    },
  },
  methods: {
    async signupToPromoteFunnel() {
      this.$loader.start('signupToPromoteFunnel');

      const funnelAffiliate = new FunnelAffiliate({});
      funnelAffiliate.funnel_id = this.selectedPromoLink.funnel;

      const gdJvCookie = Cookies.get(`gd_jv_f${this.selectedPromoLink.funnel}`);

      if (typeof gdJvCookie !== 'undefined') {
        funnelAffiliate.gd_jv_cookie = gdJvCookie;
      }

      const gsJvCookie = Cookies.get(`gs_jv_f${this.selectedPromoLink.funnel}`);

      if (typeof gsJvCookie !== 'undefined') {
        funnelAffiliate.gs_jv_cookie = gsJvCookie;
      }

      await funnelAffiliate.save();
      this.$loader.end('signupToPromoteFunnel');
      this.$emit('changedFunnel');
      this.isUserSignedUpToAffiliateProgram = 1;
    },
  },
};
</script>

<style scoped>
.gs-portal-join {
  display: grid;
  grid-template-columns: minmax(0, 380px) minmax(0, 1fr);
  gap: 24px;
  align-items: center;
  min-width: 0;
  padding: 24px;
  color: var(--gs-foreground);
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gs-portal-join__video {
  position: relative;
  margin: 0;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  background: var(--gs-surface-subtle);
  border-radius: var(--gs-radius-md);
}

.gs-portal-join__video iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  border: 0;
}

.gs-portal-join__copy {
  min-width: 0;
}

.gs-portal-join__eyebrow {
  margin: 0 0 4px;
  color: var(--gs-primary);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.gs-portal-join__title {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
}

.gs-portal-join__text {
  margin: 0 0 16px;
  color: var(--gs-muted-foreground);
  font-size: 14px;
  line-height: 1.5;
}

.gs-portal-join__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

@media (max-width: 780px) {
  .gs-portal-join {
    grid-template-columns: minmax(0, 1fr);
    gap: 18px;
    padding: 18px;
  }

  .gs-portal-join__title {
    font-size: 18px;
  }
}
</style>
